import dayjs from "dayjs";
import config from "../../../config";
import axios from "axios";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

const accidentTypes = [
  { id: 1, name: "Σύγκρουση σε προπορευόμενο όχημα" },
  { id: 2, name: "Μετωπική σύγκρουση" },
  { id: 3, name: "Πλαγιομετωπική σύγκρουση" },
  { id: 4, name: "Πλάγια σύγκρουση" },
  { id: 5, name: "Πρόσκρουση σε σταθμευμένο όχημα" },
  { id: 6, name: "Εκτροπή οχήματος" },
  { id: 7, name: "Ανατροπή οχήματος" },
  { id: 8, name: "Παράσυρση πεζού" },
];

const roadStatusVals = [
  { id: 1, name: "Στεγνό" },
  { id: 2, name: "Υγρό" },
  { id: 3, name: "Λάδια" },
  { id: 4, name: "Χαλίκι" },
  { id: 5, name: "Πάγος" },
  { id: 6, name: "Γλίτσα" },
];

const violationLabels = [
  { id: 1, name: "Διαπιστωμένη υπέρβαση του ορίου ταχύτητας" },
  { id: 2, name: "Αριστερή στροφή σε διπλή διαχωριστική γραμμή" },
  { id: 3, name: "Παραβίαση STOP/Φωτ. σηματοδότη" },
  { id: 4, name: "Παράνομη στάθμευση" },
  { id: 5, name: "Αντικανονικό προσπέρασμα" },
  { id: 6, name: "Επικίνδυνοι ελιγμοί" },
  { id: 7, name: "Παραβίαση προτεραιότητας σε κόμβο" },
  { id: 11, name: "Οδήγηση χωρίς τη νόμιμη άδεια οδήγησης" },
  { id: 9, name: "Οδήγηση υπό την επίδραση αλκοόλ" },
  { id: 10, name: "Εγκατάληψη παθόντα" },
  { id: 8, name: "Παράνομη αναστροφή" },
];

export async function fetchAccidents() {
  const displayMessage = (d) => {
    if (!d) return;

    const accidentTypeLabel = accidentTypes.find(
      (a) => a.id === d.type_accident
    )?.name;
    const roadStatusLabel = roadStatusVals.find((r) => r.id === d.road)?.name;
    const violations = d.violations
      ?.map((vId) => violationLabels.find((v) => v.id === vId)?.name)
      .filter(Boolean); // remove any undefined values

    const accidentType = accidentTypeLabel ? accidentTypeLabel : "";
    const road = roadStatusLabel
      ? `Κατάσταση Δρόμου: ${roadStatusLabel}`
      : "";
    const cause = violations?.length ? `Αιτία: ${violations.join(", ")}` : "";
    const datetime = d.date ? dayjs(d.date).format("DD/MM/YYYY HH:mm") : "";

    const message = `<div>
      <strong>${accidentType}</strong>
      <p>${road}</p>
      <p>${cause}</p>
      <p>${datetime}</p>
    </div>`;

    return message;
  };

  try {
    const response = await axios.get(`${API_URL}/accidents`, {
      headers: {
        "X-API-Key": API_TOKEN,
        "Content-Type": "application/json",
      },
    });

     console.log("fetchAccidents", response.data);

    const features = response.data.map((data) => ({
      id: data.id,
      type: "Feature",
      properties: {
        id: data.id,
        severity: data.severity,
        id_island: data.island,
        road_condition: data.road,
        date: dayjs(data.date).format("DD/MM/YYYY HH:mm"),
        description: data.description,
        displayMessage: displayMessage(data),
      },
      geometry: {
        type: "Point",
        coordinates: data.position,
      },
    }));

    return {
      data: {
        type: "FeatureCollection",
        features,
      },
      error: null,
    };
  } catch (error) {
    console.error("Error fetching form fields:", error);
    return { data: null, error: error.message || "Unknown error" };
  }
}
